import { render, staticRenderFns } from "./productDelCen.vue?vue&type=template&id=78ae50fb&scoped=true"
import script from "./productDelCen.vue?vue&type=script&lang=js"
export * from "./productDelCen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ae50fb",
  null
  
)

export default component.exports